// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import TextField from "@material-ui/core/TextField"
import grey from "@material-ui/core/colors/grey"
// eslint-disable-next-line
import IconButton from "@material-ui/core/IconButton"
// eslint-disable-next-line
import InputAdornment from "@material-ui/core/InputAdornment"
// eslint-disable-next-line
import InfoOutlined from "@material-ui/icons/InfoOutlined"
import LinkCore from "@material-ui/core/Link"
import ReCAPTCHA from "react-google-recaptcha"

// GRAPHQL
//import crossFetch from "cross-fetch"
//import { ApolloClient } from "apollo-boost"
//import { HttpLink } from "apollo-link-http";
//import { InMemoryCache } from "apollo-cache-inmemory";

import { getGqlClient,
         quickRegisterNewUser,
         readUserData,
         validateGeo
       } from "../../bl/A/bl"

// UTILS
import * as _ from "lodash"
// LogRocket
// import LogRocket from 'logrocket'

// FLASH
//import FlashLogo from "../../static/images/lightning-logo-transparent.png"
//import FlashLogo from "../../static/images/pulseai/pulseai.logo3.jpg"
import FlashLogo from "../../static/images/pulseai/pulseai.logo3.transparent.png"
import GooglePlayBadge from "../../static/images/google-play-badge.png"
import AppleStoreBadge from "../../static/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
import FlashMessage from "./../FlashMessage.js"

import {
    jsonDeleteKeys,
    deepCopy,
    jsonPointerHas
} from "../Utils"


// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Register>")
//LogRocket.init('sbqpcc/flashdev')



const styles = theme => ({
    appbarRoot: {
        height: 50
    },

    appbarMessage: {
        padding: 8,
    },

    appheadRoot: {
        height: 50,
        marginTop: 50,
        background: grey[270],
        border: "none",
        boxShadow: "none",
        zIndex: 0,
    },

    bnavbarRoot: {
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: grey[300],
    },

    
    appheadMessage: {
        padding: 8,
        width: "100%",
        textAlign: "center",
        fontWeight: 600,
    },

    contentDiv: {
        padding: 0,
        marginTop: 60,
        marginBottom: 0,
    },

    profileButton: {
        margin: 20,
        padding: 8,
        width: 200,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    textField: {
        margin: 8,
        //        padding: 8,
        width: 300,
        color: theme.palette.primary.contrastText,
        //        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            //            backgroundColor: theme.palette.primary.light,
        },
    },

    registerButton: {
        margin: 20,
        padding: 8,
        width: 200,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    titleText: {
        color: theme.palette.primary.main,
        fontSize: 21,
    },


    continueButton: {
        margin: 20,
        padding: 8,
        width: 200,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.custom.nextButton,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.custom.nextButtonLight,
        },
    },


    welcomeMessage: {
        marginTop: 20,
        // mobile
        // fontSize is working
        [theme.breakpoints.down("sm")]: {
            fontSize: 30,
        },
    },


    mobileAppIcon: {
        display: "none", // show only in mobile
        [theme.breakpoints.down("sm")]: {
            display: "block",
            margin: "0 auto",

            padding: 0,
            paddingTop: 0,
        },
    },

    textBorder: {
        "&:after": {
            borderBottomColor: "rgb(70, 197, 29)",
            borderWidth: "20px"
        }
    },

    policyDiv: {
        marginBottom: 10,
        textAlign: "center",

        // backgroundColor: grey[300],
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            maxWidth: 300,
        },
    },


    youAreRegistered_original: {
        textAlign: "center",
        fontSize: "25px",
        margin:0,
        padding:0
    },


    "@keyframes loginAnimation":  {
        "0%": {
            opacity: 0,
            marginLeft: "30%"
        },

        "40%": {
            opacity: 0.5,
        },
        
        "99%": {
            opacity: 1
        },

        "100%": {
            //color: "#43a047", // green
            //color: "#438cfe",
            color: "#008a06", // dark green
            opacity: 1,
            marginLeft: 0
        }
    },

    youAreRegistered: {
        textAlign: "center",
        fontSize: "25px",
        margin:0,
        padding:0,

        animationName: "$loginAnimation",
        animationDuration: "1s",
        animationFillMode: "forwards",
        
    },


    // NEXT: register now to be slightnily bigger and
    // fade in but not moving
    registerNow: {
        textAlign: "center",
        //fontSize: 16,
        fontSize: "1.1rem",
        margin:0,
        padding:0
    }
    
})


const CssTextField = withStyles(theme => ({
    root: {
        "& label.Mui-focused": {
            color: theme.palette.primary.main,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: theme.palette.primary.light,
        },
        "& .MuiInput-underline:after fieldset": {
            //          borderWidth: 4,
        },
        "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
                borderColor: theme.palette.primary.light,
                //          borderWidth: 4,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "& fieldset": {
                // borderRadius: 0
                borderWidth: 2, // NEXt continue here, but only make border bigger on focus
                borderColor: grey[500],
            },
            
        },
    },
}))(TextField)



//
// UTILS
//
const utils = {
    getIssues: (userData) => {
        let issues = []
        for (let len = userData.statements.length, i=0; i<len; ++i) {
            let issue = userData.statements[i].issue
            // we are "extracting the issues" from statemetns
            // so don"t double push the same issue
            if(!_.find(issues, [ "uuid", issue.uuid] )) {
                issues.push(issue)
            }
        }
        return issues
    },
    
    getUser: (userData) => {
        let user = {
            uuid: userData.uuid,
            email: userData.email,
            name: userData.name,
            loginLevel: userData.loginLevel,
            address: userData.address,
        }
        return user
    },
    getStatements: (userData) => {
        // leaving this here for historical purposes :)))
	//let statements = _.map(userData.statements, (statement) => {
        //    //            return utils.unflattenStatement(statement)
        //    return statement
        //})
        log.debug("utils.getStatements(): userData.statements = ", userData.statements)
        return userData.statements
    },

    getContacts: (userData) => {
        // leaving this here for historical purposes :)))
	//let statements = _.map(userData.statements, (statement) => {
        //    //            return utils.unflattenStatement(statement)
        //    return statement
        //})
        return userData.contacts
    },


    validateUser: (user) => {
        log.debug("validateUser(): user =", user)
        if (!user || typeof user === "undefined") {
            log.debug("validateUser(): INFO: user undefined"); return false
        } else if (!user.uuid) {
            log.debug("validateUser(): INFO: missing uuid"); return false
        } else if (!user.email) {
            log.debug("validateUser(): INFO: missing email"); return false
        } else if (!user.loginLevel) {
            log.debug("validateUser(): INFO: missing loginLevel"); return false
        } else if (!user.geo.address) {
            log.debug("validateUser(): INFO: missing address"); return false
        } else if (!user.geo.address.uuid) {
            log.debug("validateUser(): INFO: missing address.uuid"); return false
        } else if (!user.geo.address.zipPlus4) {
            log.debug("validateUser(): INFO: missing address.zipPlus4"); return false
//        } else if (!user.geo.address.isActive) {
//            log.debug("validateUser(): INFO: missing address.isActive"); return false
//        } else if (!user.geo.address.isVerified) {
//            log.debug("validateUser(): INFO: missing address.isVerified"); return false
        } else if (!user.geo.address.street) {
            log.debug("validateUser(): INFO: missing address.street"); return false
        }
        return true
    }
}


function onReCaptchaChange(value) {
   // console.log("Captcha value:", value);
}

class Register extends Component {

    state = {
        redirectHome: false,
        isInvalidEntryText: "Nothing invalid", // debugging only
        isInvalidEntryVisible: false,
        isRegistrationFinished: false
    }


    handleInvalidEntryDone = () => {
        log.debug("handleInvalidEntryDone()")
        this.setState({isInvalidEntryVisible: false})
    }

    handleZipHelpDone = () => {
        this.setState({isZipHelpVisible: false})
    }


    handleClickShowZipHelp = () => {
            this.setState({
                isZipHelpVisible: true
            })
    }
    
    
    handleTextChange = name => event => {
        log.debug(`handleTextChange(): ${name} =`, event.target.value)

        let user = this.state.user

        // top
        if(name === "name") user.name = event.target.value
        if(name === "email") user.email = event.target.value
        // address
        if(name === "street") user.geo.address.street = event.target.value
        if(name === "zipPlus4") {
            if(!user.geo.address.zip) user.geo.address.zip = {}
            user.geo.address.zipPlus4 = event.target.value
            user.geo.address.zip.code = event.target.value.split("-")[0]
            user.geo.address.zip.plus4 = event.target.value.split("-")[1] ? event.target.value.split("-")[1] : "0000"
        }

        this.setState({ user: user })
    }



    storeRegistration = _user => {
        log.debug("storeRegistration(): _user =", _user)

        const { user } = this.state
        
        log.debug("storeRegistration(): user =", user)
        
        // merged previous (saved) user and from db
        const newUser = {
            ...user,
            ..._user
        }

        
        if(jsonPointerHas(_user, "/geo/address/zip/code") && _user.geo.address.zip.code !== "") {
            newUser.geo.address.zipPlus4 = `${_user.geo.address.zip.code}`
            if(jsonPointerHas(_user, "/geo/address/zip/plus4") && _user.geo.address.zip.plus4 !== "") {
                newUser.geo.address.zipPlus4 += `-${_user.geo.address.zip.plus4}`
            }
        }
        
        log.debug("storeRegistration(): newUser =", newUser)

        localStorage.setItem("user", JSON.stringify(newUser))

        return newUser
    }

    finishRegistration = _user => {

        const { history } = this.props

        const newUser = this.storeRegistration(_user)

        history.push("/contacts")

        /*
        this.setState({
            user: newUser,
            isRegistrationFinished: true // this turns the button green and grays out the screen
        })
        */

    }

    handleQuickRegisterNewUserResult = user => {
        log.debug("handleQuickRegisterNewUserResult(): user = ", user)
        localStorage.setItem("isFirstLogon", true)
        this.finishRegistration(user)
    }

    handleQuickRegisterNewUserError = (error) => {
        log.debug("handleQuickRegisterNewUserError(): ERROR: error = ", error)
    }



    registerNewUser = async user => {
        // this this point a lot of information from the "user" can be from the saved previous user
        // these are just the attributes that we need
        log.debug("registerNewUser(): //")
        log.debug("registerNewUser(): // REGISTERING NEW USER")
        log.debug("registerNewUser(): //")
        log.debug("registerNewUser(): user = ", user)
        const newUser = jsonDeleteKeys(user,[
            "__typename", "statements", "contacts",
            "zipPlus4", "isFirstLogon", "isFirstLogin",
            "isFirstRegistration",
            "uuid"])

        log.debug("registerNewUser(): newUser =", newUser)

        await quickRegisterNewUser(newUser, {
            onResult: this.handleQuickRegisterNewUserResult,
            onError: this.handleQuickRegisterNewUserError
        })
    }

    // returns true if we only have email, which is passwordless login
    isEmailOnly = () => {
        const formUser = this.state.user
        let isEmailOnly = false
        if(formUser.email
           && !(formUser.name
                || formUser.geo.address.street
                || formUser.geo.address.zipPlus4)
          ) {
            isEmailOnly = true
        }

        return isEmailOnly
    }

    isUserChanged = (user) => {
        const dbUser = user
        const formUser = this.state.user
        log.debug("isUserChanged(): dbUser =", dbUser)
        log.debug("isUserChanged(): formUser =", formUser)

        let isChanged = false

        if(dbUser.name !== formUser.name) {
            log.debug("isUserChanged(): changed, formUser.name =", formUser.name)
            isChanged = true
        }

        if(dbUser.email !== formUser.email) {
            log.debug("isUserChanged(): changed, formUser.email =", formUser.email)
            isChanged = true
        }

        if(dbUser.geo.address.street !== formUser.geo.address.street) {
            log.debug("isUserChanged(): changed, formUser.geo.address.street =", formUser.geo.address.street)
            isChanged = true
        }

        dbUser.geo.address.zipPlus4 = `${dbUser.geo.address.zip.code}-${dbUser.geo.address.zip.plus4}`
        if(dbUser.geo.address.zipPlus4 !== formUser.geo.address.zipPlus4) {
            log.debug("isUserChanged(): changed, formUser.geo.address.zipPlus4 =", dbUser.geo.address.zipPlus4)
            isChanged = true
        }

        return isChanged
    }

    handleReadUserDataResultForLogon = user => result => {
        log.debug("handleReadUserDataResultForLogon(): //")
        log.debug("handleReadUserDataResultForLogon(): // LOGON ")
        log.debug("handleReadUserDataResultForLogon(): //")

        log.debug("handleReadUserDataResultForLogon(): OK: user = ", user)
        log.debug("handleReadUserDataResultForLogon(): OK: result = ", result)

        const loggedOnUser = deepCopy(result.data.user)
        this.finishRegistration(loggedOnUser)
    }


    handleReadUserDataErrorForLogon = user => error => {
        log.debug("handleReadUserDataErrorForLogon(): ERROR: user = ", user)
        log.debug("handleReadUserDataErrorForLogon(): ERROR: error = ", error)

        this.storeRegistration(user)
    }

    

    handleReadUserDataResultForRegister = user => result => {
        log.debug("handleReadUserDataResultForRegister(): result = ", result)
        log.debug("handleReadUserDataResultForRegister(): //")
        log.debug("handleReadUserDataResultForRegister(): // REGISTER BUTTON")
        log.debug("handleReadUserDataResultForRegister(): //")

        const dbUser = result.data.user

        log.debug("handleReadUserDataResultForRegister(): isEmailOnly() =", this.isEmailOnly())

        if(this.isUserChanged(dbUser)) { // we've changed some fields
            //
            // User changed or fresh registration
            //
            log.debug("handleReadUserDataResultForRegister(): //")
            log.debug("handleReadUserDataResultForRegister(): // USER CHANGED")
            log.debug("handleReadUserDataResultForRegister(): //")
            log.debug("handleReadUserDataResultForRegister(): calling registerNewUser()")
            // we can't have these here, it's all decided in register new user
            //registerUser.isFirstLogon = true
            //registerUser.isFirstRegistration = true
            const registerUser = deepCopy(this.state.user)
            this.registerNewUser(registerUser)
        } else {
            log.debug("handleReadUserDataResultForRegister(): //")
            log.debug("handleReadUserDataResultForRegister(): // REGULAR LOGIN")
            log.debug("handleReadUserDataResultForRegister(): //")
            // login if we have all the fields, but none of the have changed
            log.debug("handleReadUserDataResultForRegister(): calling finishRegistration(): 2")
            log.debug("handleReadUserDataResultForRegister(): dbUser = ", dbUser)
            const cleanUser = jsonDeleteKeys(dbUser,["statements", "contacts"])
            log.debug("handleReadUserDataResultForRegister(): cleanUser = ", cleanUser)
            this.finishRegistration(cleanUser)
        }
    }
    
    handleReadUserDataErrorForRegister = user => error => {
        log.debug("handleReadUserDataErrorForRegister(): error = ", error)
        log.debug("handleReadUserDataErrorForRegister(): no such user, gonna register a new one!")
        this.registerNewUser(user) // register with db
    }

    validateRegistrationForm = (user) => {
        let retObj = {valids: [], invalids: []}

        const formUser = user

        log.debug("validateRegistrationForm(): formUser =", formUser)

        if(!formUser.email || formUser.email === "") {
            retObj.invalids.push({id: "email", text: "Please enter your Email Address"})
        } else {
            retObj.valids.push({id: "email"})
        }


        if(!formUser.name || formUser.name === "") {
            retObj.invalids.push({id: "name", text: "Please enter Legal First and Last Name"})
        } else {
            retObj.valids.push({id: "name"})
        }

        if(!jsonPointerHas(formUser, "/geo/address/street") || formUser.geo.address.street === "") {
            retObj.invalids.push({id: "street", text: "Please enter your Street Name"})
        } else {
            retObj.valids.push({id: "street"})
        }

        if(!jsonPointerHas(formUser, "/geo/address/zipPlus4") || formUser.geo.address.zipPlus4 === "") {
            retObj.invalids.push({id: "zipCode", text: "Please enter Zip Code"})
        } else {
            retObj.valids.push({id: "zipCode"})
        }

        const isFieldValid = (id) => {
            return retObj.valids.find(el => el.id === id) ? true : false
        }

        const isFormValid = retObj.invalids.length === 0 ? true : false

        retObj = {
            ...retObj,
            isFieldValid,
            isFormValid
        }

        return retObj
    }

    handleRegisterButtonClick = async () => {

        localStorage.setItem("isFirstLogon", true)
        
        if(this.state.isRegistrationFinished) {
            this.setState({redirectHome: true})
            return
        }

        const formUser = this.state.user
        
        const formValidation = this.validateRegistrationForm(formUser) // current user in the form

        console.log("handleRegisterButtonClick(): validationResult, formValidation =", formValidation)

        //
        // EMAIL ONLY LOGIN
        //
        if(formValidation.isFieldValid("email")
           && !formValidation.isFieldValid("name")
           && !formValidation.isFieldValid("street")
           && !formValidation.isFieldValid("zipCode")) {
            console.log("handleRegisterButtonClick(): email logon only")

	    readUserData({
                email: formUser.email
            }, {
                // we do some extra stuff, like compare where we're changed or not
                // and re-register the user with new info if necessary, this should be factored out
                // eventually when we have a separate "login" and registration page
	        onResult: this.handleReadUserDataResultForLogon(formUser), 
	        onError: this.handleReadUserDataErrorForLogon(formUser)
	    })

            return
            
        }

        //
        // REGISTRATION VALIDATION
        //
        console.log("handleRegisterButtonClick(): regular validation")
        if(!formValidation.isFormValid) {
            console.log("handleRegisterButtonClick(): form NOT valid")
            this.setState({
                isInvalidEntryText: formValidation.invalids[0].text,
                isInvalidEntryVisible: true
            })
            return
        }

        console.log("handleRegisterButtonClick(): form YES valid")

        const validateResult = await validateGeo(formUser.geo)

        if(validateResult.isValid !== true) {
            console.log("geo NOT valid")
            // try to do push redirect here instead of other
            const { history } = this.props
            log.debug("handleRegisterButtonClick(): validateResult.validGeos =", validateResult.validGeos)
            
            const info = {
                text: "please do the right thing",
                validGeos: validateResult.validGeos
            }

            localStorage.setItem("info", JSON.stringify(info))

            const { driveSlug } = this.props.match.params
            let newUrl = "/info"
            if(driveSlug) {
                newUrl = `/drives/${driveSlug}/info`
            }
            history.push(newUrl)
        } else {
            console.log("geo YES valid")
            console.log("validGeos =", validateResult.validGeos)
        }

	readUserData({
            email: this.state.user.email
        }, {
            // we do some extra stuff, like compare where we're changed or not
            // and re-register the user with new info if necessary, this should be factored out
            // eventually when we have a separate "login" and registration page
	    onResult: this.handleReadUserDataResultForRegister(formUser), 
	    onError: this.handleReadUserDataErrorForRegister(formUser)
	})

    }

    constructor(props) {
        super(props)
        log.debug("constructor()")

        const initState =  {
            user: {
                geo: {
                    address: {
                        street: ""
                    }
                }
            }
        }

        this.state = initState
    }
    
    handleReadUserDataResult = (result) => {
        log.debug("handleReadUserDataResult(): result = ", result)

        const savedUser = this.state.user
        const dbUser = result.data.user
        log.debug("handleReadUserDataResult(): savedUser = ", savedUser)
        log.debug("handleReadUserDataResult(): dbUser = ", dbUser)

        // merge, priority dbUser
        const user = {
            ...savedUser,
            ...dbUser
        }

        log.debug("handleReadUserDataResult(): user = ", user)
    }

    handleReadUserDataError = (error) => {
        log.debug("handleReadUserDataResult(): error = ", error)
    }

    componentDidMount = () => {
        // const savedUser = JSON.parse(localStorage.getItem("user"))
        const savedUser = JSON.parse(localStorage.getItem("user"))
        localStorage.setItem("user", JSON.stringify(savedUser))
        log.debug("componentDidMount(): savedUser = ", savedUser)

        if(savedUser && savedUser.email) {
            // we have enough to try to get the user from the DB
            this.setState({
                user: {
                    ...savedUser,
                }
            })

	    readUserData({uuid: null, email: savedUser.email}, {
	        onResult: this.handleReadUserDataResult,
	        onError: this.handleReadUserDataError
	    })
            
        } else {
            log.debug("componentDidMount(): No savedUser, keep showing blanks")
            this.setState({
                user: {
                    ...this.state.user,
                }
            })
        }
    }

    
    /*
    UNSAFE_componentWillMount = () => {
        
        let user
        const savedUser = JSON.parse(localStorage.getItem("user"))
        
        if(!utils.validateUser(savedUser)) {
            log.debug("componentWillMount(): WARNING: savedUser is not valid savedUser =", savedUser)
            user = {
                uuid: "",
                name: "",
                loginLevel: "",
                geo: {
                    address: {
                        uuid: "",
                        zipPlus4: "",
                        isActive: false,
                        isVerified: false,
                        street: "",
                    },
                },
                "appIsSignedIn": false,
                "appIsSignedInType": false,
                "email": "",
                "isFirstLogon": true
            }
        } else {
            log.debug("componentWillMount(): OK: savedUser is VALID =", savedUser)
            user = savedUser
            user.isFirstLogon = false
        }
        
        const gqlClient = getGqlClient()

        this.setState({
            gqlClient: gqlClient,
            user: user
        })

    } // componentWillMount()
    */
    
    render() {
        const { classes, match } = this.props

        if (this.state.redirectHome) {
            const { driveSlug } = match.params
            if(driveSlug) {
                const newUrl = `/drives/${driveSlug}`
                return (<Redirect push to={newUrl}/>)
            }
            
            return <Redirect push to="/"/>
        }

        log.debug("render(): this.state.user = ", this.state.user)

        let touUrl = "/tou"
        let faqUrl = "/faq"
        if(match) {
            const { driveSlug } = this.props.match.params
            if(driveSlug) {
                touUrl = `/drives/${driveSlug}/tou`
                faqUrl = `/drives/${driveSlug}/faq`
            }
        }
        
	return (
            <React.Fragment>
	      <CssBaseline/>

              <FlashMessage isVisible={this.state.isInvalidEntryVisible} variant="invalidentry" text={this.state.isInvalidEntryText} onDone={this.handleInvalidEntryDone}/>

              <FlashMessage isVisible={this.state.isZipHelpVisible} variant="zipformhelp" onDone={this.handleZipHelpDone}/>

              {
                  //
                  // APPBAR
                  //
              }
              {/*              
                 <AppBar className={classes.appbarRoot} position="fixed" color="default">
                 {
                 //                <Typography className={classes.appbarMessage} variant="h6" color="inherit">
                 //                  Welcome
                 //                </Typography>
                 }
                 </AppBar>
               */}

              {
                  //
                  // APPHEAD
                  //
              }
              {/*
                 <AppBar className={classes.appheadRoot} position="fixed" color="default">
                 <Typography className={classes.appheadMessage} variant="h6" color="inherit">
                 apphead
                 </Typography>
                 </AppBar>
               */}

              {
                  //
                  // BNAVBAR
                  //
              }

              {/*
                 <div className={classes.bnavbarRoot}>
                 <Typography className={classes.appheadMessage} variant="h6" color="inherit">
                 bnavbar
                 </Typography>
                 </div>
               */}

              {
                  //
                  // Main content
                  //
              }
              <div className={classes.contentDiv}>
                {/*
                
                <div style={{ textAlign: "center"}}>
                  <img alt="logo" src={FlashLogo} style={{ height: 80 }}/>
                </div>
                
                <Typography variant="h4" style={{ textAlign: "center" }} className={classes.welcomeMessage}>
                  Welcome to Lightning
                </Typography>

                 */}


                <div style={{ textAlign: "center"}}>
                  <img alt="logo" src={FlashLogo} style={{ height: 120 }}/>
                </div>

                <div style={{marginTop: 10}}/>


                {/*
                <div style={{display: "flex", justifyContent: "center", alignItems: "flex-center", flexGrow: 1}}>
                  <div style={{color: "black"}} className={classes.titleText}><b>Lightning</b></div>
                </div>

                <div style={{marginTop: -20, display: "flex", justifyContent: "center", alignItems: "flex-center", flexGrow: 1}}>
                  <div style={{color: "#f8d337"}} className={classes.titleText}><b><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></b></div>
                </div>
                
                 */}

                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
//                    backgroundColor: "grey",
                    height: "5em"
                }}>
                {!this.state.isRegistrationFinished ? 
                 <Typography variant="h6" className={classes.registerNow} >
                  <div>Register now to be heard</div>
                  <div>by your representatives</div>
                </Typography>
                 :
                 <Typography variant="h6" className={classes.youAreRegistered} >
                   <div><b>You are now registered!</b></div>
                </Typography>
                }
                </div>
                

                {/*
                   <Typography variant="h6" style={{ textAlign: "center", marginTop: 30, fontWeight: "bold" }}>
                   Make an impact
                   </Typography>
                 */}
                <div style={{ textAlign: "center", marginTop: 5 }}>
                  <CssTextField
                    disabled={!this.state.isRegistrationFinished ? false : true}
                    id="legalname"
                    label="Legal First and Last Name"
                    className={classes.textField}
                    type="text"
                    name="name"
                    autoComplete="name"
            //      margin="normal"
                    margin="dense"
                    variant="outlined"
                    onChange={this.handleTextChange("name")}
                    value={this.state.user.name ? this.state.user.name : ""}
                  />
                  <div/>
                  <CssTextField
                    disabled={!this.state.isRegistrationFinished ? false : true}
                    id="emailaddress"
                    label="Email Address"
                    className={classes.textField}
                    type="email"
                    name="email"
                    autoComplete="email"
                    margin="dense"
                    variant="outlined"
                    value={this.state.user.email ? this.state.user.email : ""}
                    onChange={this.handleTextChange("email")}
                  />
                  <div/>
                  <CssTextField
                    disabled={!this.state.isRegistrationFinished ? false : true}
                    label="Street Name"
                    className={classes.textField}
                    type="text"
                    name="street"
                    autoComplete="street"
                    margin="dense"
                    variant="outlined"
                    value={this.state.user.geo.address.street ?  this.state.user.geo.address.street : ""}
                    onChange={this.handleTextChange("street")}
                  />                
                  <div/>
                  <CssTextField
                    disabled={!this.state.isRegistrationFinished ? false : true}
                    data-testid={"textfield-zipfield"}
                    id="zipplus4"
                    label="Zip Code"
                    className={classes.textField}
                    type="text"
                    name="zip"
                    autoComplete="zip"
                    margin="dense"
                    variant="outlined"
                    value={this.state.user.geo.address.zipPlus4 ? this.state.user.geo.address.zipPlus4 : ""}
                    onChange={this.handleTextChange("zipPlus4")}
                    inputProps={{ "data-testid": "input-zipfield" }}
                  />                
                  
                </div>


                <div style={{ display: "flex", justifyContent: "center", marginTop: 0 }}>
                  <ReCAPTCHA
                    sitekey="6LcbumEjAAAAAC1T9PgYmTgRE2BOL329ZyooQfxD"
                    onChange={onReCaptchaChange}
                  />
                </div>
                
                
                <div style={{ display: "flex", justifyContent: "center", marginTop: 0 }}>



                  
                  <Button className={!this.state.isRegistrationFinished ? classes.registerButton : classes.continueButton}
                          onClick={this.handleRegisterButtonClick}>
                    {!this.state.isRegistrationFinished ? "Register" : "Continue"}
                  </Button>
                </div>


                <div style={{ display: "flex", justifyContent: "center", marginTop: 0 }}>
                  <div className={classes.policyDiv}>

                    {this.state.isRegistrationFinished &&
                     <LinkCore href={faqUrl} variant="body1" underline="none" style={{fontSize: "1.5em", fontWeight: "bold"}}>
                       FAQ
                     </LinkCore>
                    }

                    {!this.state.isRegistrationFinished &&
                     <span>
                       <Typography variant="body1">By registering, you agree to our</Typography>
                       <LinkCore href={touUrl} color="textSecondary" variant="body1" underline="none" style={{fontWeight: "bold"}}>
                         Terms of Use
                       </LinkCore>

                       <div/>
                     <LinkCore href={faqUrl} variant="body1" underline="none" style={{fontSize: "1.5em", fontWeight: "bold"}}>
                       FAQ
                     </LinkCore>
                     </span>
                    }
            {/*
                      &nbsp;and
                      <LinkCore href="/tos" color="textSecondary" variant="body1" underline="none" style={{fontWeight: "bold"}}>
                        &nbsp;Privacy Policy
                    </LinkCore>
             */}
                  </div>
                </div>

                {/*
                   <a style={{ marginLeft: 10 }} href="https://play.google.com/apps/internaltest/4698769228490451530"><img alt="logo" src={GooglePlayBadge} style={{ height: 50 }}/></a>
                 */}
                
            {/*
                <div style={{ textAlign: "center" }} className={classes.mobileAppIcon}>

                  <a style={{ marginLeft: 10 }} href="https://play.google.com/apps/testing/com.feedbakdata.ignite"><img alt="logo" src={GooglePlayBadge} style={{ width: 120, height: 50, marginLeft: 0 }}/></a>
                  
                  <a href="https://testflight.apple.com/join/iBOpBP1H"><img alt="logo" src={AppleStoreBadge} style={{ height: 42, width: 130, paddingBottom: 8 }}/></a>
                  
                </div>
             */}

                
              </div>

            </React.Fragment>
	)
    }
}

Register.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Register" })(Register)

